import { FormsModule, NgForm } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material';
import { UtilServico } from '../servicos/util.servico';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import swal from 'sweetalert2';

declare var jquery: any;
declare var $: any;
//declare var swal: any;

interface TermoLGPD {
  PORTAL_LGP_URL: string;
  PORTAL_LGPD_TEXTO: string;
  PORTAL_LGPD_TEXTO_URL: string;
  PORTAL_LGP_HABILITAR: string;
}

@Component({
  selector: 'app-adm',
  encapsulation: ViewEncapsulation.None,

  templateUrl: './adm.component.html',
  styleUrls: ['./adm.component.scss']
})
export class AdmComponent implements OnInit {
  LOGIN: any;
  DADOSESQUECEUSENHA: any;
  Mostrar: any;
  TotalRegistro: number;
  Url: string;
  TermoLGPD: TermoLGPD | undefined;
  textoTermoPolitica: string = '';
  isTermoAceito: boolean = false;
  constructor(
    private http: Http,
    private loginServico: LoginServico,
    private router: Router,
    private UtilServico: UtilServico
    //|| window.location.href.indexOf("192.168") > 0 || window.location.href.indexOf("localhost") > 0 ||
  ) {

    //if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("192.168") > 0 || window.location.href.indexOf("10.243") > 0) {
    this.http.get("assets/config.json").subscribe(data => { this.Url = data.json().BASE_WEB_API; this.getTermoLGPD() });
    //}
    //else {
    //this.Url = window.location.href.replace('/portal/inicial', '/webapiportalmunicipios').replace('/portal/login', '/webapiportalmunicipios').replace('/portal/undefined', '/webapiportalmunicipios').replace('/NovoPortalMunicipios/login', '/webapiportalmunicipios');
    //console.log(this.Url);
    //}       


    //this.Url = window.location.href.replace('/PortalSeguradoEspiritoSanto/login', '/webapiportales');

  }

  ngOnInit() {
    this.loginServico.logout();
    this.LOGIN = {};
    this.DADOSESQUECEUSENHA = {};
  }

  AcessarSistema() {
    if (this.isTermoAceito == false && !(this.TermoLGPD.PORTAL_LGP_HABILITAR != 'S' || this.TermoLGPD.PORTAL_LGPD_TEXTO == '' || this.TermoLGPD.PORTAL_LGPD_TEXTO_URL == ''))
    {
      swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Para realizar o login é necessário aceitar o Termo de uso e Política de privacidade."
      });
    }
    else
    {
      this.Mostrar = true;
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
      let options = new RequestOptions({ headers: headers });
      this.http.post(this.Url + "/api/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            //console.log(data);
            //localStorage.setItem('DadosConfiguracoes', JSON.stringify(Object.assign(data,{ URL: this.Url })));
            localStorage.setItem('AcessoAdm', JSON.stringify(Object.assign(data, { URL: this.Url })));
            this.router.navigate(['/inicial']);
            this.Mostrar = false;
          },
          error => {
            this.Mostrar = false;
            if (error.status == 0) {
              swal.fire({
                title: "Atenção!",
                type: "warning",
                text: "Não foi possível conectar no servidor banco de dados!"
              });
            }
            else {
              swal.fire({
                title: "Atenção!",
                type: "warning",
                text: "Usuário não encontrado ou senha inválida!"
              });
            }
          }
        );
    }
  }

  aceitarTermoPoliticaPrivacidade() {
    this.getTermoLGPD();
    this.isTermoAceito = !this.isTermoAceito;
  }

  getTermoLGPD() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });

    this.http.get(this.Url + "/api/Login/GetTermoLGPD/", options).subscribe(
      data => {
        let termoLGPDData = data.json();

        // Verifica se o campo PORTAL_LGPD_TEXTO é null e atribui vazio se necessário
        let PORTAL_LGPD_TEXTO = termoLGPDData.PORTAL_LGPD_TEXTO !== null ? termoLGPDData.PORTAL_LGPD_TEXTO : '';

        this.TermoLGPD = {
          PORTAL_LGP_URL: termoLGPDData.PORTAL_LGP_URL,
          PORTAL_LGPD_TEXTO: PORTAL_LGPD_TEXTO,
          PORTAL_LGPD_TEXTO_URL: termoLGPDData.PORTAL_LGPD_TEXTO_URL,
          PORTAL_LGP_HABILITAR: termoLGPDData.PORTAL_LGP_HABILITAR
        };

        // Constrói textoTermoPolitica mesmo que PORTAL_LGPD_TEXTO seja null
        let textoTermoPolitica = "<div class='quebrarLinha'>" + (PORTAL_LGPD_TEXTO !== null ? PORTAL_LGPD_TEXTO.replace("@url", `<a class='underline-text' target="_blank" href='${this.TermoLGPD.PORTAL_LGP_URL}'>${this.TermoLGPD.PORTAL_LGPD_TEXTO_URL}</a>`) : '') + "</div>";

        this.textoTermoPolitica = textoTermoPolitica;

        console.log(this.TermoLGPD.PORTAL_LGPD_TEXTO);
        console.log(data.json());
      },
      error => {
        console.error("Erro ao obter dados do servidor:", error);
        console.log(this.Url);
      }
    );
  }

  AlterSenha() {
    //this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    if (this.DADOSESQUECEUSENHA.NOVA !== this.DADOSESQUECEUSENHA.CONFIRMA) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
    }
    else {
      this.http.post(this.Url + "/api/Login/GetTrocarSenha", JSON.stringify({ LOGIN: this.DADOSESQUECEUSENHA.CPF, SENHA: this.DADOSESQUECEUSENHA.NOVA, DATA_NASC: this.DADOSESQUECEUSENHA.DATA_NASC }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Dados não conferem com cadastro em nosso banco de dados!"
              });
            }
            else {
              this.LOGIN.USUARIO = this.DADOSESQUECEUSENHA.CPF;
              this.LOGIN.SENHA = this.DADOSESQUECEUSENHA.NOVA;
              $(document.body).removeClass("modal-open");
              $(".modal-backdrop").remove();
              this.AcessarSistema();
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/login/adm.component.ts